export interface PumpMotoLog {
  id: number;
  place_id: number;
  with_place: boolean;
  rssi: number;
  status: string;
  remote_place: string;
  with_pump: string;
  time_stamp: string;
  created_date: string;
  updated_date: string;
  system_status: string;
}

const en: any = {
  id: 1,
  place_id: 2,
  with_place: 3,
  rssi: 4,
  status: 5,
  remote_place: 6,
  with_pump: 7,
  time_stamp: 8,
  created_date: 9,
  updated_date: 10,
  system_status: 11
}
export { en };
